import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import { useStaticQuery, graphql } from 'gatsby'
import Image from 'gatsby-plugin-sanity-image'

import '../../graphql/header'

const Header = () => {
  const {
    sanityHeaderDefault: { logo, slogan, sloganEnable }
  } = useStaticQuery(graphql`
    query HeaderDefaultQuery {
      sanityHeaderDefault {
        ...HeaderParts
      }
    }
  `)

  return (
    <header className="header-main">
      <Container>
        <Row className="align-items-center justify-content-center">
          <Col xs={12} sm={12} md={4} lg={4}>
            <figure className="header-logo">
              <Image
                {...logo}
                className="d-block m-auto img-fluid"
                alt="Salesprout"
              />
              {sloganEnable && (
                <p className="header-main--slogan">{slogan}</p>
              )}
            </figure>
          </Col>
        </Row>
      </Container>
    </header>
  )
}

export default Header
